
import EntryData from '../../../views/Library/EntryData/EntryData.library.view';


export default EntryData;
